/*
 *
 * QuestionnaireLogic actions
 *
 */

import {
  ADD_STATEMENT,
  DELETE_STATEMENT,
  MOVE_STATEMENT,
  SET_SCROLL_TO_STATEMENT_ID,
  UPDATE_OUTCOME,
  ADD_RULE,
  UPDATE_RULE_OPERATOR,
  UPDATE_RULE_CONTEXT,
  ADD_CONDITION,
  DELETE_CONDITION,
  UPDATE_CONDITION,
  UPDATE_RULE_QUOTA,
  ADD_UNCONDITIONAL_HIDE_ANSWER,
  REMOVE_UNCONDITIONAL_HIDE_ANSWER,
} from './constants';

export function addStatement(payload) {
  return {
    type: ADD_STATEMENT,
    payload,
  };
}

export function deleteStatement({ nodeRefId, statementId, logicMode }) {
  return {
    type: DELETE_STATEMENT,
    payload: {
      nodeRefId,
      statementId,
      logicMode,
    },
  };
}

export function moveStatement(payload) {
  return {
    type: MOVE_STATEMENT,
    payload,
  };
}

export function setScrollToStatementId(payload) {
  return {
    type: SET_SCROLL_TO_STATEMENT_ID,
    payload,
  };
}

export function updateOutcome(payload) {
  return {
    type: UPDATE_OUTCOME,
    payload,
  };
}

export function addRule({
  nodeRefId,
  statementId,
  matcher,
  isNumeric,
  defaultValue,
  context,
  contextType,
  logicMode,
}) {
  return {
    type: ADD_RULE,
    payload: {
      nodeRefId,
      statementId,
      matcher,
      isNumeric,
      defaultValue,
      context,
      contextType,
      logicMode,
    },
  };
}

export function updateRuleOperator({
  nodeRefId,
  statementId,
  ruleId,
  value,
  logicMode,
}) {
  return {
    type: UPDATE_RULE_OPERATOR,
    payload: {
      nodeRefId,
      statementId,
      ruleId,
      value,
      logicMode,
    },
  };
}

export function updateRuleContext(payload) {
  return {
    type: UPDATE_RULE_CONTEXT,
    payload,
  };
}

export function updateRuleQuota(payload) {
  return {
    type: UPDATE_RULE_QUOTA,
    payload,
  };
}

export function addCondition(payload) {
  return {
    type: ADD_CONDITION,
    payload,
  };
}

export function deleteCondition({
  nodeRefId,
  statementId,
  ruleId,
  conditionId,
  logicMode,
}) {
  return {
    type: DELETE_CONDITION,
    payload: {
      nodeRefId,
      statementId,
      ruleId,
      conditionId,
      logicMode,
    },
  };
}

export function updateCondition({
  nodeRefId,
  statementId,
  ruleId,
  condition,
  logicMode,
}) {
  return {
    type: UPDATE_CONDITION,
    payload: {
      nodeRefId,
      statementId,
      ruleId,
      condition,
      logicMode,
    },
  };
}

export function addUnconditionalHideAnswer(payload) {
  return {
    type: ADD_UNCONDITIONAL_HIDE_ANSWER,
    payload,
  };
}

export function removeUnconditionalHideAnswer(payload) {
  return {
    type: REMOVE_UNCONDITIONAL_HIDE_ANSWER,
    payload,
  };
}
